import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 21.9999H4.33333C3.97971 21.9999 3.64057 21.8595 3.39052 21.6094C3.14048 21.3594 3 21.0202 3 20.6666V11.3333C3 10.9797 3.14048 10.6405 3.39052 10.3905C3.64057 10.1404 3.97971 9.99994 4.33333 9.99994H19C19.3536 9.99994 19.6928 10.1404 19.9428 10.3905C20.1929 10.6405 20.3333 10.9797 20.3333 11.3333V20.6666C20.3333 21.0202 20.1929 21.3594 19.9428 21.6094C19.6928 21.8595 19.3536 21.9999 19 21.9999Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.99902 10V6.66667C6.99902 5.42899 7.49069 4.242 8.36586 3.36683C9.24103 2.49167 10.428 2 11.6657 2V2C12.9034 2 14.0904 2.49167 14.9655 3.36683C15.8407 4.242 16.3324 5.42899 16.3324 6.66667V10",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.666 18.0001C12.7706 18.0001 13.666 17.1046 13.666 16.0001C13.666 14.8955 12.7706 14.0001 11.666 14.0001C10.5614 14.0001 9.66602 14.8955 9.66602 16.0001C9.66602 17.1046 10.5614 18.0001 11.666 18.0001Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgLock;
